import { createSlice } from "@reduxjs/toolkit"
import {
  deleteExportOption,
  getExportOptionsList,
} from "store/actions/exportOperationAction"

const payloadInitialState = {
  limit: 100, // set by default 100 record
  page_number: 1,
  order_by: 1, //1:Asc or -1 Desc
}

const initialState = {
  loading: false,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  exportOptions: [],
  payload: payloadInitialState,
  isShowFilter: false,
}

const exportOption = createSlice({
  name: "ExportOptions",
  initialState,
  reducers: {
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },
    resetPayload: state => {
      state.payload = payloadInitialState
    },
    toggleFilterVisibility: state => {
      state.isShowFilter = !state.isShowFilter
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getExportOptionsList.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getExportOptionsList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.exportOptions = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getExportOptionsList.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(deleteExportOption.pending, state => {
        state.loading = true
      })
      .addCase(deleteExportOption.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(deleteExportOption.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export const { setPayload, resetPayload, toggleFilterVisibility } =
  exportOption.actions
export default exportOption.reducer
